var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6657_21717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0210288 8.39831L0.00194559 5.00586C-0.0129025 3.20646 -0.00654062 0.350373 2.53248 0.149026C5.69725 -0.102075 9.15474 0.0372144 12.3556 0.0499444L18.3319 0.0360462C21.0852 0.026923 24.5755 -0.439422 24.6508 3.42425C24.6827 5.08531 24.6445 6.75285 24.6424 8.41401L24.636 26.0818L24.653 31.0308C24.6699 33.9136 25.0252 37.023 21.0884 36.9992C14.9996 36.9625 8.87686 37.0589 2.79232 36.9449C1.56629 36.9544 0.186482 35.6803 0.103757 34.4552C-0.0712385 31.8766 0.0284601 29.0475 0.0284601 26.4512L0.0210288 8.39831Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0210288 8.39831L0.00194558 5.00586C-0.0129025 3.20647 -0.00654059 0.350373 2.53248 0.149026C5.69725 -0.102075 9.15474 0.0372144 12.3556 0.0499444L18.3319 0.0360462C21.0852 0.026923 24.5755 -0.439422 24.6508 3.42426C24.6827 5.08532 24.6445 6.75285 24.6424 8.41401C18.3796 8.23791 11.4286 8.42919 5.09485 8.40532C3.62276 8.47427 1.53872 8.40383 0.0210288 8.39831Z",
    fill: "#DC2E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0210287 8.39831L0.00194558 5.00586C-0.0129025 3.20647 -0.00654062 0.350373 2.53248 0.149026C5.69725 -0.102075 9.15474 0.0372144 12.3556 0.0499444C12.1498 0.838465 12.2909 7.06876 12.3047 8.30803C11.2112 8.30941 5.77468 8.22657 5.09485 8.40532C3.62276 8.47427 1.53872 8.40383 0.0210287 8.39831Z",
    fill: "#FC513D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5868 2.80428C21.4269 2.6948 21.1638 5.18671 20.3037 6.10593C18.6036 6.1281 18.8613 3.7254 19.5868 2.80428Z",
    fill: "#DC2221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0564 23.3509C20.3429 23.0303 21.6442 23.8161 21.9603 25.1036C22.2763 26.3913 21.4862 27.6906 20.1976 28.0023C18.9153 28.3125 17.6246 27.5269 17.3096 26.2456C16.9957 24.9644 17.7763 23.6699 19.0564 23.3509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1138 16.8817C20.4024 16.5954 21.6782 17.4059 21.9678 18.6935C22.2573 19.9812 21.4502 21.26 20.1627 21.5522C18.872 21.8454 17.5887 21.0346 17.2991 19.7428C17.0085 18.4509 17.822 17.169 19.1138 16.8817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7219 23.3544C12.4431 23.1797 13.2036 23.3496 13.7826 23.8141C14.3606 24.2788 14.6905 24.9855 14.6756 25.7274C14.6534 26.8128 13.9035 27.7475 12.8493 28.0037C11.565 28.3155 10.2721 27.5271 9.9603 26.2429C9.64955 24.9588 10.4376 23.6653 11.7219 23.3544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6166 29.823C12.3335 29.6151 13.1067 29.7544 13.7059 30.1994C14.3062 30.6446 14.6636 31.3444 14.6721 32.0913C14.6848 33.1638 13.9816 34.1136 12.9529 34.4147C11.6844 34.7855 10.3555 34.057 9.98644 32.788C9.61736 31.519 10.347 30.191 11.6166 29.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7648 16.8831C12.4786 16.7243 13.2263 16.9018 13.7937 17.3648C14.3601 17.8278 14.6835 18.5252 14.6697 19.2569C14.6507 20.3425 13.9019 21.2785 12.8477 21.5353C12.013 21.7386 11.1338 21.4779 10.5452 20.8528C9.95548 20.2276 9.74761 19.3342 10 18.513C10.2524 17.6919 10.9259 17.0695 11.7648 16.8831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31251 29.8306C5.57991 29.4648 6.90351 30.1961 7.26941 31.4638C7.63425 32.7316 6.90244 34.0556 5.63505 34.4206C4.36766 34.7855 3.04512 34.0542 2.68028 32.787C2.31438 31.5197 3.04512 30.1962 4.31251 29.8306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.013 10.5046C19.8477 10.2791 20.7385 10.5223 21.342 11.1405C21.9465 11.7587 22.1693 12.6553 21.9253 13.4846C21.6803 14.3139 21.0079 14.9462 20.1648 15.1378C18.8974 15.426 17.6321 14.6473 17.3192 13.3857C17.0053 12.1243 17.7583 10.8437 19.013 10.5046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0082 29.816C19.8429 29.5893 20.7338 29.8314 21.3383 30.4488C21.9439 31.0662 22.1666 31.9625 21.9238 32.7919C21.6798 33.6211 21.0064 34.2539 20.1643 34.4458C18.8979 34.7344 17.6337 33.9572 17.3198 32.6971C17.0048 31.4371 17.7557 30.1567 19.0082 29.816Z",
    fill: "#DC2E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45187 23.3476C5.73092 23.06 7.00255 23.8594 7.29846 25.137C7.59436 26.4148 6.80317 27.6916 5.5273 27.9956C4.24081 28.3022 2.95009 27.5023 2.65207 26.213C2.35299 24.9236 3.16114 23.6378 4.45187 23.3476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46349 16.8834C5.74255 16.5991 7.011 17.4011 7.30372 18.6788C7.59644 19.9566 6.80313 21.231 5.52725 21.5318C4.23971 21.8355 2.95217 21.0329 2.65627 19.7433C2.36143 18.4539 3.1717 17.1704 4.46349 16.8834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39204 10.5013C5.67322 10.1765 6.97454 10.9576 7.29059 12.2418C7.60559 13.526 6.81652 14.8219 5.53004 15.129C4.25628 15.4332 2.97616 14.6524 2.66329 13.3807C2.35042 12.109 3.12252 10.8231 4.39204 10.5013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7147 10.5003C12.9938 10.1829 14.2866 10.965 14.6006 12.2452C14.9145 13.5254 14.1286 14.817 12.8474 15.1269C11.5716 15.4356 10.2872 14.6536 9.97539 13.3787C9.66252 12.1038 10.441 10.8164 11.7147 10.5003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5396 7.58842C18.112 7.58677 17.7441 7.48153 17.4359 7.27273C17.1293 7.06392 16.8932 6.76148 16.7275 6.36541C16.5634 5.96934 16.4822 5.4929 16.4838 4.93608C16.4838 4.38092 16.5659 3.90779 16.7299 3.51669C16.8957 3.12559 17.1318 2.82812 17.4384 2.62429C17.7466 2.4188 18.1137 2.31605 18.5396 2.31605C18.9655 2.31605 19.3317 2.4188 19.6383 2.62429C19.9466 2.82978 20.1835 3.12808 20.3493 3.51918C20.515 3.90862 20.597 4.38092 20.5953 4.93608C20.5953 5.49455 20.5125 5.97183 20.3468 6.3679C20.1827 6.76397 19.9474 7.06641 19.6408 7.27521C19.3342 7.48402 18.9672 7.58842 18.5396 7.58842ZM18.5396 6.69602C18.8313 6.69602 19.0641 6.54936 19.2381 6.25604C19.4121 5.96271 19.4983 5.52273 19.4966 4.93608C19.4966 4.54995 19.4569 4.22846 19.3773 3.97159C19.2994 3.71473 19.1884 3.52166 19.0442 3.3924C18.9017 3.26314 18.7335 3.19851 18.5396 3.19851C18.2496 3.19851 18.0176 3.34351 17.8436 3.63352C17.6696 3.92353 17.5817 4.35772 17.5801 4.93608C17.5801 5.32718 17.619 5.65365 17.6969 5.91548C17.7765 6.17566 17.8883 6.37121 18.0325 6.50213C18.1767 6.63139 18.3457 6.69602 18.5396 6.69602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6657_21717",
    x: 0,
    y: 0,
    width: 25.668,
    height: 38.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6657_21717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6657_21717",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.89bce2f75378d2cd6d047e506d00cca2.svg";
export { ForwardRef as ReactComponent };